import { useEffect, useState } from "react";

const links = [
  { label: "最新实锤", href: "#latest" },
  { label: "时间线", href: "#timeline" },
  { label: "热度榜", href: "#hot" },
  { label: "细节对比", href: "#contrast" },
  { label: "原帖存档", href: "#archive" },
  { label: "甄别FAQ", href: "#faq" },
];

export default function TopNav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={
        "fixed top-0 left-0 right-0 z-50 transition-all duration-300 " +
        (scrolled
          ? "bg-background-50/90 backdrop-blur border-b border-background-200/80"
          : "bg-transparent")
      }
    >
      <nav className="mx-auto flex h-16 w-full max-w-[1240px] items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-lg font-bold text-background-50">
            黑
          </span>
          <span className="font-heading text-xl font-black tracking-tight text-foreground-950">
            黑料<span className="ml-1 align-super text-[10px] font-bold tracking-widest text-primary-500">HEILIAO</span>
          </span>
        </a>

        <div className="hidden items-center gap-1 md:flex">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="whitespace-nowrap rounded-full px-3 py-1.5 text-sm text-foreground-700 transition-colors hover:bg-primary-50 hover:text-primary-700"
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="hidden items-center gap-2 md:flex">
          <a
            href="#faq"
            className="whitespace-nowrap rounded-full border border-foreground-300 px-4 py-1.5 text-sm text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
          >
            投稿 / 线索
          </a>
          <a
            href="#latest"
            className="whitespace-nowrap rounded-full bg-primary-500 px-4 py-1.5 text-sm text-background-50 transition-colors hover:bg-primary-600"
          >
            开始吃瓜
          </a>
        </div>

        <button
          aria-label="打开菜单"
          onClick={() => setOpen((v) => !v)}
          className="flex h-9 w-9 items-center justify-center rounded-md bg-background-100 text-xl text-foreground-800 md:hidden"
        >
          <i className={open ? "ri-close-line" : "ri-menu-line"}></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
          <div className="flex flex-col gap-1">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-2 text-sm text-foreground-800 hover:bg-background-100"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#faq"
              onClick={() => setOpen(false)}
              className="mt-2 rounded-full bg-primary-500 px-4 py-2 text-center text-sm text-background-50"
            >
              投稿 / 提供线索
            </a>
          </div>
        </div>
      )}
    </header>
  );
}